// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__zz6qH","rootSuccess":"CompleteLink_rootSuccess__2JagQ","rootFailure":"CompleteLink_rootFailure__3DOaX","isDisabled":"CompleteLink_isDisabled__2TOQZ"};